import { env } from '@/core/config/env';
import { API_V1 } from '@/core/api/endpoints';
import type { FieldValueFile } from '../types';

function isFieldValueFile(value: unknown): value is FieldValueFile {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as Record<string, unknown>).storageKey === 'string' &&
    typeof (value as Record<string, unknown>).fileName === 'string'
  );
}

/** Parses a `Files`/`Signature` field's raw `FieldValue.value` JSON string. */
export function parseFieldValueFile(raw: string | null): FieldValueFile | null {
  if (!raw) return null;
  try {
    const parsed: unknown = JSON.parse(raw);
    return isFieldValueFile(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

/** Builds the downloadable URL for a stored file from its `storageKey`. */
export function buildFileUrl(storageKey: string): string {
  return `${env.VITE_API_URL}${API_V1}/files/${storageKey}`;
}
